import { useEffect, useRef, useState } from "react";
import { Button, Popover, Input, message, Checkbox } from "antd";
import { FilterOutlined, MenuOutlined } from "@ant-design/icons";
import API_MANAGER from "../../../API";
import MobilzationTransferCampaignDropdown from "./MobilzationTransferCampaignDropdown";

export const TransferPopover = ({
  candidateSelectedData,
  transferData,
  oldAdvertId,
  setReloadState,
  setCurrentPage,
  setSearch,
  search,
  setadvertIds,
  advertIds,
  setfilterDataUser,
  reloadState,
  searchText,
  sortValue,
  setLoadingTable,
  setActiveLoader,
  refreshToggle,
  currentPage,
  settotalRecord,
  setbadgeIds,
  setmobilzationColumn,
  setDeselectTrigger,
  setfilterDataAdvert,
  isArchiveView,
  selectedAdverts,
  setSelectedAdverts,
  data,
  columns,
  isFilterUsing,
  setIsFilterUsing
}) => {
  const [visibleFilter, setVisibleFilter] = useState(false);
  const [newAdvertId, setNewAdvertId] = useState("");

  const [inviteIds, setInviteIds] = useState({});
  console.log(selectedAdverts.length, "LENG");

  const [debouncedSearchText, setDebouncedSearchText] = useState(searchText);

  const skipNextFetchRef = useRef(false);

  console.log(searchText,setadvertIds,"OPPPPPPPPPP");

  const [searchKeyword, setSearchKeyword] = useState("");

  const [ids, setids] = useState([]);

  const advertIdsfinal = transferData.flatMap(
    (item) => item.adverts?.map((ad) => ad._id) || []
  );
  const lastAppliedRef = useRef({
    searchText,
    sortValue,
    advertIdsfinal,
    currentPage,
  });

  const isInitialFilterMountRef = useRef(true);

  useEffect(() => {
    if (isInitialFilterMountRef.current) {
      isInitialFilterMountRef.current = false;
      const isRestoring = localStorage.getItem("restoreFilters") === "true";
      if (isRestoring || (selectedAdverts && selectedAdverts.length > 0)) {
        return;
      }
    }

    setSelectedAdverts([]);
    setbadgeIds([]);
    setInviteIds({});
    setNewAdvertId("");
    setSearchKeyword("");
    setVisibleFilter(false);
    setadvertIds([]);
    setfilterDataAdvert([]);
    setDeselectTrigger(true);
    skipNextFetchRef.current = true;
  }, [isArchiveView]);

  console.log(refreshToggle, "refreshToggle");
  
  // Restore filters from Redux on mount if they exist
  useEffect(() => {
    const isRestoring = localStorage.getItem("restoreFilters") === "true";
    if (isRestoring && selectedAdverts && selectedAdverts.length > 0) {
      console.log("TransferPopover: Restoring selectedAdverts from Redux:", selectedAdverts);
      // Ensure selectedAdverts from Redux are set
      // The parent should already have them, but make sure they're not cleared
    }
  }, []); // Run only on mount
  
  // Extract all advert _ids

  const handleOkBtn = () => {
    console.log(ids, "logids");
    // transferApplication();
  };


useEffect(() => {
  const handler = setTimeout(() => {
    setDebouncedSearchText(searchText);
  }, 500);

  return () => clearTimeout(handler);
}, [searchText]);

  // Select All state
  const [selectAll, setSelectAll] = useState(false);
  const handleSelectAll = () => {
    if (selectedAdverts.length > 0) {
      setSelectedAdverts([]);
      setbadgeIds([]);
      setSelectAll(false);
      // Reset to page 1 when deselecting all filters
      setCurrentPage(1);
      // Trigger API call to return to initial state when deselecting all
      setDeselectTrigger(true);
      // Force a refresh to show all data
      localStorage.setItem("applyTrigger", "true");
      // Reset filter using state
      setIsFilterUsing(false);
    } else {
      setSelectedAdverts([...advertIdsfinal]);
      setbadgeIds([...advertIdsfinal]);
      setSelectAll(true);
      applyInitial();
      setDeselectTrigger(true);
      // Set filter using state to true when selecting all
      setIsFilterUsing(true);
    }
  };
  const debounceTimer = useRef(null);
useEffect(() => {
  const controller = new AbortController();

  const fetchData = async () => {
    // Determine which adverts to use - prioritize selectedAdverts from Redux when restoring
    const isRestoring = localStorage.getItem("restoreFilters") === "true";
    const restoreSelectedAdvertsStr = localStorage.getItem("restoreSelectedAdverts");
    const restoreSelectedAdverts = restoreSelectedAdvertsStr ? JSON.parse(restoreSelectedAdvertsStr) : [];
    
    // Priority: restoreSelectedAdverts > selectedAdverts > advertIdsfinal
    let advertsToUse;
    if (isRestoring && restoreSelectedAdverts.length > 0) {
      advertsToUse = restoreSelectedAdverts;
      console.log("🔄 Using selectedAdverts from localStorage restoration");
    } else if (selectedAdverts.length > 0) {
      advertsToUse = selectedAdverts;
      console.log("🔄 Using selectedAdverts from Redux/props");
    } else {
      advertsToUse = advertIdsfinal;
      console.log("🔄 Using all adverts (advertIdsfinal)");
    }
    
    console.log("📡 API Triggered", {
      isRestoring,
      selectedAdvertsCount: selectedAdverts.length,
      restoreSelectedAdvertsCount: restoreSelectedAdverts.length,
      advertIdsfinalCount: advertIdsfinal.length,
      advertsToUseCount: advertsToUse.length,
      usingSelectedAdverts: advertsToUse !== advertIdsfinal,
      firstFewIds: advertsToUse.slice(0, 5) // Log first 5 IDs for debugging
    });
    
    setLoadingTable(true);
    setActiveLoader(true);

    const data = {
      adverts: advertsToUse,
      searchText: debouncedSearchText,
      sortValue,
      currentPage,
    };
    
    console.log("📤 API Request Data:", {
      adverts: advertsToUse.length,
      advertIds: advertsToUse.slice(0, 10), // First 10 IDs
      searchText: debouncedSearchText,
      sortValue,
      currentPage
    });

    try {
      const response = isArchiveView
        ? await API_MANAGER.postGateDataArchive(data)
        : await API_MANAGER.postGateData(data);
      if (response.data?.isSuccess) {
        setmobilzationColumn(response?.data?.data?.column);
        setfilterDataUser(response?.data?.data?.users);
        settotalRecord(response?.data?.data?.totalRecords);

        lastAppliedRef.current = {
          searchText: debouncedSearchText,
          sortValue,
          advertIdsfinal: [...advertIdsfinal],
          currentPage,
        };
      }
    } catch (error) {
      message.error("Filter operation failed.");
    } finally {
      setLoadingTable(false);
      setActiveLoader(false);
      localStorage.removeItem("applyTrigger");
    }
  };

  const filtersChanged =
    selectedAdverts.length > 0 ||
    debouncedSearchText !== lastAppliedRef.current.searchText ||
    sortValue !== lastAppliedRef.current.sortValue ||
    JSON.stringify(advertIdsfinal) !== JSON.stringify(lastAppliedRef.current.advertIdsfinal);

  const shouldCallApi =
    filtersChanged || 
    currentPage !== lastAppliedRef.current.currentPage ||
    localStorage.getItem("restoreFilters") === "true";

  // Check if any filters are actually applied
  const hasActiveFilters = selectedAdverts.length > 0 || 
    (debouncedSearchText && debouncedSearchText.trim() !== "") || 
    (sortValue && sortValue !== "recentlyAdded");

  // Handle filter restoration from Redux - MUST BE FIRST CHECK
  const restoreFilters = localStorage.getItem("restoreFilters") === "true";
  const restoreSelectedAdvertsStr = localStorage.getItem("restoreSelectedAdverts");
  const restoreSelectedAdverts = restoreSelectedAdvertsStr ? JSON.parse(restoreSelectedAdvertsStr) : [];
  
  // Wait for transferData to be available before restoring
  if (restoreFilters && advertIdsfinal.length > 0) {
    // Use restored selectedAdverts from localStorage if available, otherwise use from props
    const advertsToRestore = restoreSelectedAdverts.length > 0 ? restoreSelectedAdverts : selectedAdverts;
    
    // Check if we have filters to restore (selectedAdverts or searchText)
    const hasFiltersToRestore = advertsToRestore.length > 0 || 
                                (debouncedSearchText && debouncedSearchText.trim() !== "") ||
                                (sortValue && sortValue !== "recentlyAdded");
    
    if (hasFiltersToRestore) {
      console.log("✅ RESTORING FILTERS - calling API with saved state", {
        selectedAdvertsFromProps: selectedAdverts.length,
        selectedAdvertsFromStorage: restoreSelectedAdverts.length,
        advertsToRestore: advertsToRestore.length,
        selectedAdvertsIds: advertsToRestore.slice(0, 10), // Log first 10 IDs
        searchText: debouncedSearchText,
        sortValue,
        currentPage,
        advertIdsfinal: advertIdsfinal.length,
        transferDataAvailable: transferData?.length || 0,
        willUseSelectedAdverts: advertsToRestore.length > 0
      });
      
      // CRITICAL: Ensure selectedAdverts are set in Redux before calling API
      if (advertsToRestore.length > 0 && selectedAdverts.length === 0) {
        console.log("🔧 Setting selectedAdverts from localStorage restoration:", advertsToRestore.length);
        setSelectedAdverts([...advertsToRestore]);
        // Wait a tick for Redux to update, then call API
        setTimeout(() => {
          fetchData();
          localStorage.removeItem("restoreFilters");
          localStorage.removeItem("restoreSelectedAdverts");
          setIsFilterUsing(true);
          
          // Update lastAppliedRef to prevent duplicate calls
          lastAppliedRef.current = {
            searchText: debouncedSearchText,
            sortValue,
            advertIdsfinal: [...advertsToRestore], // Store the actual adverts used
            currentPage,
          };
          
          // Clear the skip flag since we've restored
          skipNextFetchRef.current = false;
        }, 100);
        return;
      }
      
      // If selectedAdverts already set, call API immediately
      if (advertsToRestore.length > 0) {
        console.log("✅ Using restored selectedAdverts for API call:", advertsToRestore.length, "advert IDs");
      } else {
        console.warn("⚠️ No selectedAdverts found in Redux or storage - will use all adverts");
      }
      
      fetchData();
      localStorage.removeItem("restoreFilters");
      localStorage.removeItem("restoreSelectedAdverts");
      setIsFilterUsing(true);
      
      // Update lastAppliedRef to prevent duplicate calls
      lastAppliedRef.current = {
        searchText: debouncedSearchText,
        sortValue,
        advertIdsfinal: advertsToRestore.length > 0 ? [...advertsToRestore] : [...advertIdsfinal],
        currentPage,
      };
      
      // Clear the skip flag since we've restored
      skipNextFetchRef.current = false;
      return;
    } else {
      // No filters to restore, clear the flag
      console.log("RestoreFilters flag set but no filters found - clearing flag");
      localStorage.removeItem("restoreFilters");
      localStorage.removeItem("restoreSelectedAdverts");
    }
  }

  // BLOCK all API calls if we're in the middle of restoring filters
  if (restoreFilters && advertIdsfinal.length > 0) {
    console.log("⏸️ Blocking API calls - restoration in progress");
    return; // Exit early - restoration logic above will handle the API call
  }

  // Reset to page 1 only when user actually applies filters
  if (advertIdsfinal.length && hasActiveFilters && filtersChanged && !isFilterUsing) {
    setCurrentPage(1);
    fetchData();
    setIsFilterUsing(true);
    return;
  }

  // Only trigger API when ready (but NOT if we're restoring)
  if (advertIdsfinal.length && shouldCallApi && !restoreFilters) {
    if (skipNextFetchRef.current) {
      // Skip this run once after view switch to avoid double fetch
      skipNextFetchRef.current = false;
    } else {
      fetchData();
    }
  }

  // Removed auto-reset based on applyTrigger; rely on explicit user actions

  // Update isFilterUsing state based on current filter status
  if (isFilterUsing !== hasActiveFilters) {
    setIsFilterUsing(hasActiveFilters);
  }

  return () => {
    controller.abort();
  };
}, [
  selectedAdverts,
  debouncedSearchText,
  sortValue,
  refreshToggle,
  currentPage,
  JSON.stringify(advertIdsfinal),
]);


  const applyInitial = async () => {
    console.log("API 2 Trigger");
    const storedTrigger = localStorage.getItem("applyTrigger");

    if (
      lastAppliedRef.current.searchText === searchText &&
      lastAppliedRef.current.sortValue === sortValue &&
      JSON.stringify(lastAppliedRef.current.advertIdsfinal) ===
        JSON.stringify(advertIdsfinal)
    ) {
      return;
    }

    if (
      (!storedTrigger || storedTrigger !== "true") &&
      !searchText &&
      !sortValue
    )
      return;
    if (!advertIdsfinal.length) return;

    setLoadingTable(true);
    // setActiveLoader(true);

    try {
        const response = isArchiveView
          ? await API_MANAGER.postGateDataArchive({
              adverts: advertIdsfinal,
              searchText: searchText,
              sortValue: sortValue,
              currentPage,
            })
          : await API_MANAGER.postGateData({
              adverts: advertIdsfinal,
              searchText: searchText,
              sortValue: sortValue,
              currentPage,
            });

      if (response.data.isSuccess) {
        setmobilzationColumn(response?.data?.data?.column);
        setfilterDataUser(response?.data?.data?.users);
         settotalRecord(response?.data?.data?.totalRecords);

        lastAppliedRef.current = {
          searchText,
          sortValue,
          advertIdsfinal: [...advertIdsfinal],
        };
      }
    } catch (error) {
      message.error("Advert application failed.");
    } finally {
      setLoadingTable(false);
      setActiveLoader(false);
      localStorage.removeItem("applyTrigger");
    }
  };

  // useEffect(() => {
  //   console.log("TRIGGER");
  //   if (!advertIdsfinal.length) {
  //     applyInitial();
  //   }
  // }, [
  //   searchText,
  //   sortValue,
  //   JSON.stringify(advertIdsfinal),
  //   refreshToggle,
  //   currentPage,
  //   selectedAdverts,
  // ]);

  // useEffect(() => {
  //   applyInitial();
  // }, [selectAll]);

  useEffect(() => {
    // Don't run if we're restoring filters (let the main useEffect handle it)
    const isRestoring = localStorage.getItem("restoreFilters") === "true";
    if (isRestoring) {
      console.log("TransferPopover: Skipping transferApplication - restoration in progress");
      return;
    }
    
    console.log("API 3 Trigger");
    const transferApplication = async () => {
      const data = {
        adverts: advertIdsfinal,
        searchText: searchText,
        sortValue: sortValue,
        currentPage,
      };

      setLoadingTable(true);
      // setActiveLoader(true);
      try {
        const response = isArchiveView
          ? await API_MANAGER.postGateDataArchive(data)
          : await API_MANAGER.postGateData(data);
        console.log(response, "&&&");
        setmobilzationColumn(response?.data?.data?.column);
        setfilterDataUser(response?.data?.data?.users);
        settotalRecord(response?.data?.data?.totalRecords);

        if (response.data.isSuccess) {
          // message.success("Successfully Filtered.");
        }
      } catch (error) {
        // message.error("Filter Operation Failed.");
      } finally {
        setLoadingTable(false);
        setActiveLoader(false);
      }
    };

    // ✅ Only call API if selectedAdverts has data
    if (selectedAdverts.length === 0) {
      if (skipNextFetchRef.current) {
        // Skip once after view switch
        skipNextFetchRef.current = false;
      } else {
        transferApplication();
      }
    }
  }, [ids, selectedAdverts,refreshToggle,currentPage]);

  // const transferApplication = async () => {
  //   console.log(ids, ")))");
  //   const data = {
  //     adverts: ids,
  //   };
  //   console.log(data, "TEST IDT");
  //   try {
  //     const response = await API_MANAGER.postGateData(data);
  //     if (response.data.isSuccess === true) {
  //       message.success("Successfully Filtered.");
  //       // setReloadState(true);
  //     }
  //   } catch (error) {
  //     message.error("Filter Operation  Failed.");
  //   }
  // };

  const contentFilter = (
    <div
      style={{
        width: 300,
        background: "#fff",
        borderRadius: 8,
        padding: 15,
        boxShadow: "0px 4px 10px rgba(0,0,0,0.15)",
      }}
    >
      <h4
        style={{
          color: "#1E1E1E",
          // fontFamily: "Inter",
          fontSize: 14,
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "normal",
          textTransform: "uppercase",
          alignSelf: "stretch",
          marginBottom: 8,
        }}
      >
        FILTERS
      </h4>

      {/* Select All Checkbox */}
      <Checkbox
        checked={selectedAdverts.length > 0}
        onChange={handleSelectAll}
        style={{ marginBottom: 10 }}
      >
        {selectedAdverts.length > 0 ? "Deselect All" : "Select All"}
      </Checkbox>

      <Input
        placeholder="Search campaigns or adverts"
        value={searchKeyword}
        onChange={(e) => setSearchKeyword(e.target.value)}
        allowClear
        style={{ marginBottom: 12 }}
      />

      {/* <Input
        className="search-input mb-20"
        size="large"
        placeholder="Select or search campaign"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      /> */}

      <h4
        style={{
          color: "#1E1E1E",
          marginTop: 8,
          fontSize: 14,
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "normal",
          textTransform: "uppercase",
          alignSelf: "stretch",
          marginBottom: 8,
          position: "relative",
          display: "inline-block",
        }}
      >
        campaigns & Adverts
      </h4>
      <div className="campaignListContainer">
        {(searchKeyword.trim() === ""
          ? transferData
          : transferData
              ?.filter((item) => {
                const campaignMatch = item?.name
                  ?.toLowerCase()
                  .includes(searchKeyword.toLowerCase());

                const advertMatch = Array.isArray(item?.adverts)
                  ? item.adverts.some((ad) =>
                      ad?.jobTitle?.name
                        ?.toLowerCase()
                        .includes(searchKeyword.toLowerCase())
                    )
                  : false;

                return campaignMatch || advertMatch;
              })
              ?.map((item) => {
                const campaignMatch = item?.name
                  ?.toLowerCase()
                  .includes(searchKeyword.toLowerCase());

                return {
                  ...item,
                  adverts: Array.isArray(item?.adverts)
                    ? campaignMatch
                      ? item.adverts
                      : item.adverts.filter((ad) =>
                          ad?.jobTitle?.name
                            ?.toLowerCase()
                            .includes(searchKeyword.toLowerCase())
                        )
                    : [],
                };
              })
        )?.map((item, index) => (
          <MobilzationTransferCampaignDropdown
            setInviteIds={setInviteIds}
            inviteIds={inviteIds}
            item={item}
            key={index}
            setNewAdvertId={setNewAdvertId}
            setSelectedAdverts={setSelectedAdverts}
            setfilterDataAdvert={setfilterDataAdvert}
            selectedAdverts={selectedAdverts}
            setadvertIds={setadvertIds}
            handleOkBtn={handleOkBtn}
            advertIds={advertIds}
            setids={setids}
            setbadgeIds={setbadgeIds}
          />
        ))}
      </div>
      {/* <div
        style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}
      >
        <Button type="primary" onClick={handleOkBtn}>
          Assign
        </Button>
        <Button
          style={{ marginLeft: 10 }}
          onClick={() => setVisibleFilter(false)}
        >
          Cancel
        </Button>
      </div> */}
    </div>
  );

  return (
    <Popover
      overlayClassName="mobilisation-filter-popover"
      arrow={false}
      content={contentFilter}
      trigger="click"
      placement="bottomLeft"
      open={visibleFilter}
      onOpenChange={(visible) => setVisibleFilter(visible)}
      overlayStyle={{
        border: "none",
        boxShadow: "none",
      }}
      overlayInnerStyle={{
        backgroundColor: "#fff",
        padding: "0px",
      }}
    >
      <Button
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          background: "#F8FAFC",
          border: "1px solid #E2E8F0",
          borderRadius: "8px",
          padding: "20px 12px",
          fontSize: "14px",
          fontWeight: "500",
          color: "#64748B",
          cursor: "pointer",
          boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "28px",
            height: "28px",
            background: "#EEF4FF",
            borderRadius: "6px",
          }}
        >
          <MenuOutlined style={{ fontSize: "16px", color: "#1638B1" }} />
        </div>
        Filter By
      </Button>
    </Popover>
  );
};
